import { Tooltip } from 'antd';
import Icon from '.';

const EnrichmentIcon = ({
  title = 'Created by Enrichment',
  color = '#FF612C',
  size = '1x',
}) => {
  return (
    <Tooltip title={title}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Icon icon='upload' color={color} size={size} />
      </div>
    </Tooltip>
  );
};

export default EnrichmentIcon;
